import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../Loader";
import moment from "moment/moment";
import { Button, Modal, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Checkbox, TextField, MenuItem, Select, InputLabel, FormControl } from "@mui/material";
import { GetInvestors } from '../../Redux/Actions/strategyService';

const UserStatusTable = ({ onSelectionChange }) => {
  const dispatch = useDispatch();
  const [userStatusData, setUserStatusData] = useState([]);
  const { InvestorsData, loading } = useSelector((state) => state.strategy);
  const { userInfo } = useSelector((state) => state.user);
  const { portal = "MANAGER" } = userInfo;
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStrategy, setSelectedStrategy] = useState("");
  const entityId= localStorage.getItem("entId")
 
  useEffect(() => {
    dispatch(GetInvestors({portal, entityId}));
  }, [dispatch, portal]);

  useEffect(() => {
    if (InvestorsData && InvestorsData.length > 0) {
      const filteredData = InvestorsData.filter((item) => item.parentRole == null);
      setUserStatusData(filteredData);
    }
  }, [InvestorsData]);

  const handleOpen = (rowData) => {
    setSelectedRow(rowData);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  const handleSelectUser = (userId) => {
    setSelectedUsers((prev) => {
      const newSelected = prev.includes(userId)
        ? prev.filter((id) => id !== userId) // Deselect user
        : [...prev, userId]; // Select user
      const selectedUserData = userStatusData.filter(user => newSelected.includes(user.id)); // Get full user data
      onSelectionChange(selectedUserData); // Lift state up with full user data
      return newSelected;
    });
  };

  const data = userStatusData.map((item, index) => {
    const { userRole, createdAt, custodian, strategy } = item || {};
    const { user } = userRole || {};
    const { email } = user || {};
    const formattedDate = createdAt ? moment(createdAt).format("DD/MM/YYYY") : "N/A";
    return {
      id: item.id, // Assuming each item has a unique id
      index: index + 1,
      email: email || "",
      regDate: formattedDate,
      investorType: userRole?.role || "",
      custodian: strategy.custodian || "",
      strategyName: strategy?.name || "",
      hurdleRateType: strategy?.hurdleRateType || "N/A",
      hurdleRatePercentage: strategy?.hurdleRatePercentage || "N/A",
      benchmarkType: strategy?.benchmarkType || "N/A",
      securityType: strategy?.securityType || "N/A",
    };
  });

  // Filter data based on search term and selected strategy
  const filteredData = data.filter((row) => {
    const matchesSearch = Object.values(row).some(value =>
      value.toString().toLowerCase().includes(searchTerm.toLowerCase())
    );
    const matchesStrategy = selectedStrategy ? row.strategyName === selectedStrategy : true;
    return matchesSearch && matchesStrategy;
  });

  // Get unique strategies for dropdown
  const strategies = [...new Set(data.map((row) => row.strategyName))];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <TableContainer component={Paper} style={{marginTop:"20px"}}>
          <div style={{ marginBottom: "20px", marginTop:"20px", marginLeft:"10px" }}>
            <TextField
              label="Search the Data"
              variant="outlined"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ marginRight: "20px" }}
            />
            <FormControl variant="outlined" style={{ minWidth: 220 }}>
              <InputLabel>Select Strategy</InputLabel>
              <Select
                value={selectedStrategy}
                onChange={(e) => setSelectedStrategy(e.target.value)}
                label="Strategy"
              >
                <MenuItem value="">
                  <em>All</em>
                </MenuItem>
                {strategies.map((strategy) => (
                  <MenuItem key={strategy} value={strategy}>
                    {strategy}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                 
                </TableCell>
                <TableCell>#</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Reg Date</TableCell>
                <TableCell>Investor Type</TableCell>
                <TableCell>Custodian</TableCell>
                <TableCell>Strategy</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((row) => (
                <TableRow key={row.id}>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={selectedUsers.includes(row.id)}
                      onChange={() => handleSelectUser(row.id)}
                    />
                  </TableCell>
                  <TableCell>{row.index}</TableCell>
                  <TableCell>{row.email}</TableCell>
                  <TableCell>{row.regDate}</TableCell>
                  <TableCell>{row.investorType}</TableCell>
                  <TableCell>{row.custodian}</TableCell>
                  <TableCell>{row.strategyName}</TableCell>
                  <TableCell>
                    <Button variant="contained" color="primary" onClick={() => handleOpen(row)}>
                      Action
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
      <Modal open={open} onClose={handleClose}>
        <div style={{ padding: "20px", backgroundColor: "white", margin: "150px auto", maxWidth: "500px" }}>
          <h2>User Strategy Details</h2>
          {selectedRow ? (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>Strategy Name</th>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>{selectedRow.strategyName}</td>
                </tr>
                <tr>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>Hurdle Rate Type</th>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>{selectedRow.hurdleRateType}</td>
                </tr>
                <tr>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>Hurdle Rate Percentage</th>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>{selectedRow.hurdleRatePercentage}</td>
                </tr>
                <tr>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>Benchmark Type</th>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>{selectedRow.benchmarkType}</td>
                </tr>
                <tr>
                  <th style={{ border: "1px solid #ccc", padding: "8px" }}>Security Type</th>
                  <td style={{ border: "1px solid #ccc", padding: "8px" }}>{selectedRow.securityType}</td>
                </tr>
              </tbody>
            </table>
          ) : (
            <p>No data</p>
          )}
          <br />
          <Button onClick={handleClose} variant="contained" color="primary">Close</Button>
        </div>
      </Modal>
    </>
  );
};

export default UserStatusTable;
